import { useTranslation } from '@/shared/core/hooks/use-translation/use-translation.ts'
import { ScrollIndicator } from '@/teams/portfolio/components/scroll-indicator/scroll-indicator.tsx'
import { ExperienceCards } from '@/teams/portfolio/components/section/experience-section/experience-cards/experience-cards.tsx'
import { Section } from '@/teams/portfolio/components/section/section/section.tsx'
import '@/teams/portfolio/components/section/experience-section/experience-section.scss'

export function ExperienceSection() {
	const { t } = useTranslation()

	return (
		// biome-ignore lint/correctness/useUniqueElementIds: Static ID needed for URL anchor navigation
		<Section
			ariaLabel={t('portfolio.section.experience.ariaLabel')}
			id='experience'>
			<div className='experience-section'>
				<h2 className='experience-section__title'>
					{t('portfolio.section.experience.title')}
					<span
						aria-hidden='true'
						className='experience-section__title-underline'
					/>
				</h2>

				<div className='experience-section__content'>
					<ExperienceCards />
				</div>

				<ScrollIndicator targetSection='projects' />
			</div>
		</Section>
	)
}
